const STORAGE_KEY = 'auth_data'

// Load from localStorage on init
const loadFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const parsed = JSON.parse(stored)
      return {
        user: parsed.user || null,
        token: parsed.token || null,
        isAuthenticated: !!parsed.token
      }
    }
  } catch (e) {
    console.error('Error loading auth from storage:', e)
  }
  return {
    user: null,
    token: null,
    isAuthenticated: false
  }
}

let authState = loadFromStorage()

const saveToStorage = () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      user: authState.user,
      token: authState.token
    }))
  } catch (e) {
    console.error('Error saving auth to storage:', e)
  }
}

const clearStorage = () => {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    console.error('Error clearing auth storage:', e)
  }
}

const login = (userData, tokens) => {
  authState = {
    user: userData,
    token: tokens.accessToken,
    isAuthenticated: true
  }
  saveToStorage()
}

const logout = () => {
  authState = {
    user: null,
    token: null,
    isAuthenticated: false
  }
  clearStorage()
}

const getAuthHeader = () => {
  return authState.token ? { Authorization: `Bearer ${authState.token}` } : {}
}

const useAuthStore = () => {
  return {
    ...authState,
    login,
    logout,
    getAuthHeader
  }
}

// For non-React usage (api.js)
useAuthStore.getState = () => ({
  ...authState,
  login,
  logout,
  getAuthHeader
})

export { useAuthStore }
